import React, { useEffect } from 'react'
import { StyleSheet, TouchableOpacity } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { observer } from 'mobx-react-lite'
import { useRouter } from 'expo-router'

import { DS } from '../../design-system'
import { useStore } from '../../models'
import { useSubscriptionGuard } from '../../hooks/useSubscriptionGuard'
// import { getAvailablePurchases } from 'react-native-iap'
import { MembershipTypes } from '../../models/api-store'
import { extendLogger, LoggerContexts } from '../../utils/logger'

const logger = extendLogger(LoggerContexts.ManageMembershipScreen)

const ManageMembership: React.FC = observer(() => {
  const router = useRouter()
  const {
    memberships: { isApple },
    api: { mutateRestorePurchase }
  } = useStore()

  useSubscriptionGuard()
  const goToStripeAccount = () => {
    router.navigate('/lobby/membership-stripe')
  }

  const goBackButton = () => {
    router.navigate('/lobby/membership')
  }

  const handleRestorePurchase = async () => {
    // try {
    //   logger.debug('Trying to restore purchase...')
    //   const availablePurchases = await getAvailablePurchases()
    //   logger.debug('Available purchases', availablePurchases)
    //   const tiers = Object.values(MembershipTypes).map((level) => level.toLowerCase())
    //   logger.debug('Tiers', tiers)
    //   const member = availablePurchases.find((x) => tiers.includes(x.productId.toLowerCase()))
    //   logger.debug('Member', member)
    //   if (member?.originalTransactionDateIOS) {
    //     const currentTier = member.productId.toLowerCase()
    //     logger.debug('Restoring purchase for tier', currentTier)
    //     mutateRestorePurchase({
    //       startOfPeriod: member.originalTransactionDateIOS,
    //       tier: currentTier as MembershipTypes
    //     })
    //   }
    //   logger.debug('Purchase restored')
    // } catch (error) {
    //   logger.error('Error in handleRestorePurchase', error)
    //   console.log('Error in handleRestorePurchase', error)
    // }
  }

  return (
    <DS.Frame style={styles.wrapperContainer}>
      <DS.Frame style={styles.headerDivider} />
      <SafeAreaView style={styles.safeAreaContainer}>
        <DS.Frame style={styles.container}>
          <DS.Frame style={styles.headerContainer}>
            <DS.Text variant="Heading 2/Medium">Manage Membership</DS.Text>
            <TouchableOpacity style={styles.closeButton} onPress={goBackButton}>
              <DS.Icon name="Close" size={16} color="Global/Black" />
            </TouchableOpacity>
          </DS.Frame>

          <DS.Frame style={styles.card}>
            <TouchableOpacity style={styles.cardButton} onPress={() => router.navigate('/lobby/membership-plan')}>
              <DS.Text variant="Body Large/Regular">Plans</DS.Text>
              <DS.Icon name="Arrow--right-wide" size={16} color="Global/Black" />
            </TouchableOpacity>
            {isApple ? null : (
              <>
                <DS.Frame style={styles.divider} />
                <TouchableOpacity
                  style={styles.cardButton}
                  onPress={() => router.navigate('/lobby/membership-billing-details')}
                >
                  <DS.Text variant="Body Large/Regular">Billing Details</DS.Text>
                  <DS.Icon name="Arrow--right-wide" size={16} color="Global/Black" />
                </TouchableOpacity>
              </>
            )}
          </DS.Frame>
          {isApple ? null : (
            <TouchableOpacity style={styles.stripeButton} onPress={goToStripeAccount}>
              <DS.Text variant="Body Large/Regular">Stripe Account</DS.Text>
              <DS.Icon name="Arrow--top-right" size={16} color="Global/Black" />
            </TouchableOpacity>
          )}
          {isApple ? (
            <DS.Button
              type="On Light"
              textAlign="center"
              textColor="Global/Black"
              onPress={handleRestorePurchase}
              variant="Small/Secondary"
              rightIcon={null}
              style={styles.restoreButton}
              centerContent
              leftIcon={<DS.Icon name="Plus--enclosed" size={20} color="Global/Black" />}
            >
              Restore Purchase
            </DS.Button>
          ) : null}
        </DS.Frame>
      </SafeAreaView>
    </DS.Frame>
  )
})

const styles = StyleSheet.create({
  wrapperContainer: {
    flex: 1,
    backgroundColor: DS.palette['Brand/Cream']
  },
  safeAreaContainer: {
    flex: 1,
    backgroundColor: DS.palette['Brand/Cream'],
    borderTopRightRadius: 24,
    borderTopLeftRadius: 24,
    transform: [{ translateY: -24 }]
  },
  container: {
    padding: 24,
    backgroundColor: DS.palette['Brand/Cream'],
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    position: 'relative',
    borderTopRightRadius: 24,
    borderTopLeftRadius: 24
  },
  headerContainer: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: 16
  },
  card: {
    width: '100%',
    maxHeight: 108,
    borderWidth: 1,
    borderColor: DS.palette['Brand/Cream'],
    borderRadius: 16,
    backgroundColor: DS.palette['Global/White'],
    marginTop: 24,
    padding: 16,
    justifyContent: 'space-between',
    gap: 16
  },
  cardButton: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  closeButton: {
    padding: 8,
    backgroundColor: DS.palette['Brand/Light Grey'],
    borderRadius: 16,
    position: 'absolute',
    top: -10,
    right: 0
  },
  stripeButton: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: DS.palette['Global/White'],
    padding: 16,
    width: '100%',
    borderRadius: 16,
    marginTop: 24
  },
  headerDivider: {
    height: 90,
    backgroundColor: DS.palette['Global/Black'],
    width: '100%'
  },
  divider: {
    height: 1,
    backgroundColor: DS.palette['Brand/Cream'],
    width: '100%'
  },
  restoreButton: { justifyContent: 'center', marginTop: 12, width: '100%' }
})

export default ManageMembership
